export enum DataFlowModuleControlTypes {
  Direct = 'Direct',
  Flow = 'Flow',
  Gate = 'Gate',
  Helper = 'Helper'
}
